import jBob from 'jbob';

class Utils {
    static init()
    {
        this.jbob = new jBob();
    }

    static j()
    {
        return this.jbob;
    }

    static lang()
    {
        return $('html').attr('lang');
    }

    static feedbackToast(message, color)
    {
        let toast = $('<div class="toast-container position-fixed bottom-0 end-0 p-3" data-bs-delay="2000"> \
            <div id="liveToast" class="toast show bg-' + color + '" role="alert"> \
                <div class="toast-body">' + message + '</div> \
            </div> \
        </div>');

        toast.appendTo('body').toast('show').on('hidden.bs.toast', (e) => {
            $(e.currentTarget).remove();
        });
    }

    /*
        https://stackoverflow.com/a/29939024
    */
    static base64ToBlob(base64, mimetype, slicesize) {
        if (!window.atob || !window.Uint8Array) {
            return null;
        }

        mimetype = mimetype || '';
        slicesize = slicesize || 512;
        var bytechars = atob(base64);
        var bytearrays = [];
        for (var offset = 0; offset < bytechars.length; offset += slicesize) {
            var slice = bytechars.slice(offset, offset + slicesize);
            var bytenums = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                bytenums[i] = slice.charCodeAt(i);
            }

            var bytearray = new Uint8Array(bytenums);
            bytearrays[bytearrays.length] = bytearray;
        }

        return new Blob(bytearrays, {type: mimetype});
    }
}

export default Utils;
